import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    translation: {
      common: {
        loading: 'Loading...',
        error: 'An error occurred',
        retry: 'Retry',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        create: 'Create',
        update: 'Update',
        back: 'Back',
        next: 'Next',
        search: 'Search',
        noResults: 'No results found',
        confirm: 'Confirm',
        success: 'Success',
        warning: 'Warning',
        required: 'Required',
        optional: 'Optional',
      },
      auth: {
        login: 'Login',
        logout: 'Logout',
        email: 'Email',
        password: 'Password',
        forgotPassword: 'Forgot password?',
        createAccount: 'Create account',
        noAccount: "Don't have an account?",
        hasAccount: 'Already have an account?',
      },
      workspace: {
        select: 'Select Workspace',
        create: 'Create Workspace',
        name: 'Workspace Name',
        switch: 'Switch Workspace',
        settings: 'Workspace Settings',
      },
      navigation: {
        dashboard: 'Dashboard',
        recordGroups: 'Record Groups',
        automations: 'Automations',
        roles: 'Roles & Permissions',
        permissions: 'User Permissions',
        subscription: 'Subscription',
        developer: 'Developer Dashboard',
        developerWorkspaces: 'Developer Workspaces',
        developerUsers: 'Developer Users',
        developerAnalytics: 'Developer Analytics',
      },
      dashboard: {
        edit: 'Edit Dashboard',
        save: 'Save Layout',
        addWidget: 'Add Widget',
        visibility: 'Visibility',
      },
      subscription: {
        currentPlan: 'Current Plan',
        changePlan: 'Change Plan',
        cancelSubscription: 'Cancel Subscription',
        trialEnds: 'Trial ends',
        cancelsOn: 'Cancels on',
        expired: 'Subscription Expired',
        choosePlan: 'Choose a plan to continue',
        upgrade: 'Upgrade',
        lockedResource: 'Resource Locked',
        upgradeToUnlock: 'Upgrade to unlock',
      },
      errors: {
        invalidCredentials: 'Invalid email or password',
        sessionExpired: 'Your session has expired. Please login again.',
        networkError: 'Network error. Please check your connection.',
        forbidden: 'You do not have permission to perform this action.',
        notFound: 'The requested resource was not found.',
        quotaExceeded: 'You have reached your usage limit.',
        subscriptionExpired: 'Your subscription has expired.',
      },
    },
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n